<template>
<div class="chapter">
<div class="inner_page">
<p class="imager"><img alt="Images" src="images/f000v-01.jpg"/></p>
<p class="dedication"><a id="dedication"></a><a id="page_v"><span class="txit">To the supersweet students at Seely Place Elementary!</span></a></p><a id="page_v">
<p class="image2"><img alt="Images" src="images/f000v-02.jpg"/></p>
<p class="image3"><img alt="Images" src="images/f000v-03.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?72bc4a09